import { createContext } from "react";
import { CellEntryStore } from "../../store";

export const CellEntryContext = createContext<CellEntryStore | null>(null);
